export const LogoMark = ({ className = "w-9 h-9", light = false }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill={light ? "#F4F2EC" : "#111111"} />
    <path d="M14 16h9l9 14 9-14h9L36 37v11h-8V37z" fill={light ? "#111111" : "#F4F2EC"} />
    <rect x="14" y="52" width="36" height="3" rx="1.5" fill="#D7261E" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark light={light} />
    <span className={`font-display text-xl font-bold tracking-tight ${light ? "text-white" : "text-[var(--ink)]"}`}>
      YOU<span className="text-[var(--red)]">CARS</span>
    </span>
  </span>
);
